module.exports = __webpack_public_path__ + "img/6.e45d38d9.png";